<template>
  <div>
    <TableVisualizationLayout :leftInfo="leftInfo" :leftAction="leftAction" :showTable="false">
      <template slot="headerContent">
        <div class="d-flex justify-content-center w-100 my-4">
          <div class="d-inline-block">
            <div class="text-left mb-2 custom-label">Status:</div>

            <div class="d-flex align-items-center">
              <div class="form-check form-check-inline mr-5">
                <input v-model="status" class="form-check-input" type="radio" id="chk-status-todos" value="TODOS">
                <label class="form-check-label ml-1" for="chk-status-todos">Todos</label>
              </div>

              <div class="form-check form-check-inline mr-5">
                <input v-model="status" class="form-check-input" type="radio" id="chk-status-ativo" value="ACTIVE">
                <label class="form-check-label ml-1" for="chk-status-ativo">Ativos</label>
              </div>

              <div class="form-check form-check-inline mr-5">
                <input v-model="status" class="form-check-input" type="radio" id="chk-status-afastado" value="AWAY">
                <label class="form-check-label ml-1" for="chk-status-afastado">Afastados</label>
              </div>

              <div class="form-check form-check-inline">
                <input v-model="status" class="form-check-input" type="radio" id="chk-status-excluido" value="DELETED">
                <label class="form-check-label ml-1" for="chk-status-excluido">Excluídos</label>
              </div>
            </div>

            <div class="text-left mb-2 custom-label mt-3">CRM (Opcional)</div>
            <div class="mb-4">
                <MultiSelectCrm 
                    @onSelectCrm="onSelectCrm" 
                    :crms="selectedCrms" 
                    placeholder="Digite e selecione"
                />
                <div class="lbl-info-crm mt-2">
                    Se não preenchido, o relatório exibirá todos os CRMs.
                </div>
            </div>

            <div class="d-flex justify-content-center mt-5">
              <b-button 
                variant="primary" 
                class="d-flex align-items-center btn-download-custom"
                @click="onDownloadClick"
                :disabled="loading"
              >
                <i v-if="!loading" class="fas fa-download mr-3"></i>
                <i v-else class="fas fa-spinner fa-spin mr-3"></i>
                Gerar Relatório
              </b-button>
            </div>
          </div>
        </div>
      </template>
    </TableVisualizationLayout>
  </div>
</template>

<script>
import TableVisualizationLayout from '../../layouts/TableVisualizationLayout.vue';
import MultiSelectCrm from '../../components/multiselect-crm/MultiSelectCrm.vue';
import { downloadContactEmergencyReport } from '../../services/contactsEmergency/contactsEmergencyService';
import { anchorBase64Download } from '../../utils/anchor-base64-download/anchor-base64-download.js';
import { inject } from "@vue/composition-api";
import { createToast } from '../../components/toast/toast.js';

export default {
  components: {
    TableVisualizationLayout,
    MultiSelectCrm
  },
  data() {
    return {
      status: 'TODOS',
      loading: false,
      selectedCrms: [],
      leftAction: {
        text: "Relatório de Referências",
        onClick: this.leftActionClickHandler,
      },
      leftInfo: ""
    }
  },
  setup() {
    const globalLoading = inject("globalLoading");
    return { globalLoading };
  },
  methods: {
    onSelectCrm(crms) {
      this.selectedCrms = crms;
    },
    leftActionClickHandler() {
      this.$router.go(-1);
    },
    async onDownloadClick() {
      try {
        this.globalLoading = true;
        const filters = { 
          status: this.status === 'TODOS' ? null : this.status,          
          crms: this.selectedCrms.join(',') 
        };
        
        const response = await downloadContactEmergencyReport(filters);

        if (response && response.fileBase64) {
          anchorBase64Download(
            null,
            response.contentType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            response.fileName || "Relatorio_Contatos.xlsx",
            response.fileBase64
          );

           createToast(
            "Sucesso",
            "Download concluído com sucesso.",
            "success",
            10000
          );
        } else if (response.message) {           
            createToast("Informação", response.message, "warning");
        }
      } catch (error) {
        console.error("Erro ao baixar relatório", error);
      } finally {
        this.globalLoading = false;
      }
    }
  },
}
</script>

<style scoped>

.custom-label,
.form-check-label {
    color: #212529;
    font-family: "Trebuchet MS", Helvetica, sans-serif; 
    font-size: 16px;
    font-weight: 400;
}

.btn-download-custom {    
    padding: 6px 12px;   
}

button.btn-download-custom {
    color: #FFF;
    text-align: center;
    font-family: "Trebuchet MS" !important;
    font-size: 16px !important;
    font-style: normal;
}

.lbl-info-crm {
    color: var(--text-02-muted, #6C757D);
    font-family: "Trebuchet MS";
    font-size: 12.8px;
    font-style: normal;
}

</style>